import React, { FC, Suspense } from 'react'

import { lazyImport } from '@utils/lazyImport'

const { Age } = lazyImport(
  () =>
    import(/*webpackChunkName: 'age-dialog'*/ '@components/Dialogs/Age/Age'),
  'Age'
)

export const LazyAge: FC = () => {
  return (
    <Suspense fallback={null}>
      <Age />
    </Suspense>
  )
}
